import app from 'flarum/forum/app';
import Footer from 'flarum/forum/components/Footer';
import Link from 'flarum/common/components/Link';
import { override } from 'flarum/common/extend';
import PrivacyPage from './components/PrivacyPage';
import { canManageConsent, initializeConsentApi, showConsentSettings } from './consent';
const NOTICE_STORAGE_KEY = 'aooci.cookieNotice.accepted.v1';
let noticeAccepted = false;
function hasAcceptedNotice() {
  try {
    return window.localStorage.getItem(NOTICE_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}
function acceptNotice() {
  try {
    window.localStorage.setItem(NOTICE_STORAGE_KEY, '1');
  } catch {
    // The notice can still be dismissed for this page when storage is blocked.
  }
  noticeAccepted = true;
  m.redraw();
}
app.initializers.add('aooci-adsense-privacy', () => {
  app.routes.aoociPrivacy = {
    path: '/privacy',
    component: PrivacyPage
  };
  initializeConsentApi();
  noticeAccepted = hasAcceptedNotice();
  override(Footer.prototype, 'view', function () {
    if (noticeAccepted) return null;
    return m("div", {
      className: "AoociPrivacyDialogWrap",
      role: "dialog",
      "aria-modal": "false",
      "aria-label": app.translator.trans('aooci-adsense.forum.footer.dialog_label')
    }, m("div", {
      className: "AoociPrivacyDialog"
    }, m("div", {
      className: "AoociPrivacyDialog-content"
    }, m("span", null, app.translator.trans('aooci-adsense.forum.footer.notice')), ' ', m(Link, {
      href: app.route('aoociPrivacy')
    }, app.translator.trans('aooci-adsense.forum.footer.policy_link'))), m("div", {
      className: "AoociPrivacyDialog-actions"
    }, canManageConsent() ? m("button", {
      className: "Button",
      type: "button",
      onclick: showConsentSettings
    }, app.translator.trans('aooci-adsense.forum.footer.settings_button')) : null, m("button", {
      className: "Button Button--primary",
      type: "button",
      onclick: acceptNotice
    }, app.translator.trans('aooci-adsense.forum.footer.accept_button')))));
  });
});